import { render, staticRenderFns } from "./HeroCard.vue?vue&type=template&id=0655e623&scoped=true&"
import script from "./HeroCard.vue?vue&type=script&lang=js&"
export * from "./HeroCard.vue?vue&type=script&lang=js&"
import style0 from "./HeroCard.vue?vue&type=style&index=0&id=0655e623&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0655e623",
  null
  
)

export default component.exports